import * as basicLightbox from 'basiclightbox';

const basiclightbox = () => {
    document.addEventListener("DOMContentLoaded", (e) => {
        const elencoVideo = document.querySelectorAll('.videoSingolo');
        if (elencoVideo.length > 0) {
            elencoVideo.forEach(video => video.addEventListener('click', e => clickVideoHandler(e)));
        }
    });

    function clickVideoHandler(e) {
        const videoDiv = e.target.closest('div');
        if (videoDiv !== null) {
            const videoCode = videoDiv.getAttribute('data-video');
            if (videoCode !== "") {
                basicLightbox.create(`
                    <iframe width="60%" height="70%" src="https://www.youtube-nocookie.com/embed/${videoCode}?rel=0" frameborder="0" allowfullscreen></iframe>
                `).show();
            }
        }
    }

    document.addEventListener("DOMContentLoaded", (e) => {
        const elencoImmagini = document.querySelectorAll('.zoomImage');
        if (elencoImmagini.length > 0) {
            elencoImmagini.forEach(image => image.addEventListener('click', e => clickImageHandler(e)));
        }
    });

    function clickImageHandler(e) {
        console.log(e.target);

        const imageUrl = e.target.getAttribute('data-url');
        if (imageUrl !== "") {
            basicLightbox.create(`
                <img src="${imageUrl}">
            `).show();
        }
    }
};

export default basiclightbox;